const FormatedLanguageEnum = Object.freeze({
  Čeština: ' Ceština (Ceská republika)',
  Deutsch: ' Deutsch (Deutschland)',
  Français: ' Français (France)',
  Slovenčina: ' Slovencina (Slovensko)',
  Español: ' Español (España)',
  English: ' English (United States)',
})

export default FormatedLanguageEnum
